export default __webpack_public_path__ + "static/media/logo_sc.05a74763.svg";